<svg-icon *ngIf="loaded"
          class="flex layout-row layout-align-start-center fade-element-in-only"
          [name]="iconName"
          [svgStyle]="{ 'fill': fill || 'currentColor', 'height': height, 'width': width}"
          [ngClass]="classSize"
          data-toggle="tooltip"
          [ngbTooltip]="tooltip">

</svg-icon>
